"use strict";

import {siteConfig} from './siteConfig';

//var azure = siteConfig
var server;

if (process.env.NODE_ENV === "localhost") {
    server = "http://localhost:3000/api";
    // server = "http://localhost:3001/api";
    //  server = "https://field.voolks.com/api";
    server = "https://field-test.voolks.com/api";
}
else if (process.env.NODE_ENV === "dev2") {
    server = "http://localhost:3001/api";
}
else if (process.env.NODE_ENV === "voolks-prod") {
    server = "https://field.voolks.com/api";
}
else if (process.env.NODE_ENV === "voolks-dev") {
    server = "https://field-test.voolks.com/api";
}
else if (process.env.NODE_ENV === "migrations-dev") {
    server = "http://52.184.192.108/api/";
}
else {
    throw new Error("NODE_ENV environment variable isn't properly set");
}
if (siteConfig && siteConfig.serverUrl) {
    // server = siteConfig.serverUrl;
    // Eliminar '/' final si existe
    server = siteConfig.serverUrl.endsWith('/')
        ? siteConfig.serverUrl.slice(0, -1)
        : siteConfig.serverUrl;
}
module.exports = {
    server: server
}
